import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { SubComponentContainer, Label, CheckboxesGroup, FilterHeader } from '#component/general/list-filter/components/general/styles';
import MobileFilterCheckbox from './mobile-filter-checkbox';

export const MultipleCheckboxes = ({
  name,
  label,
  relatedTo,
  options,
  onChange
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const selected = useSelector(s => s.listFilter?.[relatedTo]?.[name]?.value, shallowEqual);
  const [checked, setChecked] = useState([]);

  useEffect(() => {
    setChecked(selected ?? []);
  }, [selected]);

  const handleToggle = value => () => {
    const currentChecked = checked.find(c => c.data.id === value.data.id);
    const currentIndex = checked.indexOf(currentChecked);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    onChange(newChecked);
  };

  return (
    isMobile ? (
      <div>
        <FilterHeader fontWeight={500} color="textSecondary">{label}</FilterHeader>
        <CheckboxesGroup>
          {options?.map(option => (
            <MobileFilterCheckbox
              key={option.label}
              label={option.label}
              selected={!!checked.find(c => c.data.id === option.data.id)}
              onToggle={handleToggle(option)}
            />
          ))}
        </CheckboxesGroup>
      </div>
    ) : (
      <SubComponentContainer>
        <Label>{label}</Label>
        <CheckboxesGroup>
          {options?.map(option => (
            <FormControlLabel
              checked={!!checked.find(c => c.data.id === option.data.id)}
              key={option.label}
              control={<Checkbox />}
              label={option.label}
              onChange={handleToggle(option)}
            />
          ))}
        </CheckboxesGroup>
      </SubComponentContainer>
    )
  );
};
